import type {
  CreditCardFormMessages,
  CreditCardMessageTranslator,
} from './creditCardTypes'

export const DEFAULT_CREDIT_CARD_FORM_MESSAGES: CreditCardFormMessages = {
  payWith: 'Pay with', // i18n-exempt: checkout core English fallback
  securityNotice: 'Your card number is encrypted and secure.', // i18n-exempt: checkout core English fallback
  cardNumberLabel: 'Card number', // i18n-exempt: checkout core English fallback
  cardNumberPlaceholder: 'Card number', // i18n-exempt: checkout core English fallback
  expiryLabel: 'MM/YY', // i18n-exempt: checkout core English fallback
  expiryPlaceholder: 'MM/YY', // i18n-exempt: checkout core English fallback
  cvvLabel: 'CVV', // i18n-exempt: checkout core English fallback
  cvvPlaceholder: 'CVV', // i18n-exempt: checkout core English fallback
  zipLabel: 'ZIP code', // i18n-exempt: checkout core English fallback
  zipPlaceholder: 'ZIP code', // i18n-exempt: checkout core English fallback
  cardNumberInvalid: 'Enter a valid credit or debit card number.', // i18n-exempt: checkout core English fallback
  cardTypeUnsupported: 'Card type not supported.', // i18n-exempt: checkout core English fallback
  expiryMissing: 'Enter expiration date.', // i18n-exempt: checkout core English fallback
  expiryInvalid: 'Enter a valid expiration date.', // i18n-exempt: checkout core English fallback
  cvvMissing: 'Enter CVV.', // i18n-exempt: checkout core English fallback
  cvvInvalidThreeDigits: 'Enter the 3-digit security code.', // i18n-exempt: checkout core English fallback
  cvvInvalidFourDigits: 'Enter the 4-digit security code.', // i18n-exempt: checkout core English fallback
  zipMissing: 'Enter ZIP code.', // i18n-exempt: checkout core English fallback
  zipInvalid: 'Enter a valid ZIP code.', // i18n-exempt: checkout core English fallback
}

export function resolveCreditCardFormMessages(
  translate?: CreditCardMessageTranslator,
): CreditCardFormMessages {
  if (translate === undefined) return DEFAULT_CREDIT_CARD_FORM_MESSAGES
  const defaults = DEFAULT_CREDIT_CARD_FORM_MESSAGES
  return {
    payWith: translate('payWith', defaults.payWith),
    securityNotice: translate('securityNotice', defaults.securityNotice),
    cardNumberLabel: translate('cardNumberLabel', defaults.cardNumberLabel),
    cardNumberPlaceholder: translate(
      'cardNumberPlaceholder',
      defaults.cardNumberPlaceholder,
    ),
    expiryLabel: translate('expiryLabel', defaults.expiryLabel),
    expiryPlaceholder: translate(
      'expiryPlaceholder',
      defaults.expiryPlaceholder,
    ),
    cvvLabel: translate('cvvLabel', defaults.cvvLabel),
    cvvPlaceholder: translate('cvvPlaceholder', defaults.cvvPlaceholder),
    zipLabel: translate('zipLabel', defaults.zipLabel),
    zipPlaceholder: translate('zipPlaceholder', defaults.zipPlaceholder),
    cardNumberInvalid: translate(
      'cardNumberInvalid',
      defaults.cardNumberInvalid,
    ),
    cardTypeUnsupported: translate(
      'cardTypeUnsupported',
      defaults.cardTypeUnsupported,
    ),
    expiryMissing: translate('expiryMissing', defaults.expiryMissing),
    expiryInvalid: translate('expiryInvalid', defaults.expiryInvalid),
    cvvMissing: translate('cvvMissing', defaults.cvvMissing),
    cvvInvalidThreeDigits: translate(
      'cvvInvalidThreeDigits',
      defaults.cvvInvalidThreeDigits,
    ),
    cvvInvalidFourDigits: translate(
      'cvvInvalidFourDigits',
      defaults.cvvInvalidFourDigits,
    ),
    zipMissing: translate('zipMissing', defaults.zipMissing),
    zipInvalid: translate('zipInvalid', defaults.zipInvalid),
  }
}
